const Index = () => import( /* webpackChunkName: "global" */ './index');
const ViewInvoice = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/View.vue');
const ViewEvent = () => import( /* webpackChunkName: "global" */ '@/modules/Events/components/View.vue');
const ViewSubscription = () => import( /* webpackChunkName: "global" */ '@/modules/Subscription/components/View.vue');
const DonorInvoice = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/DonorInvoice.vue');
const ViewDeletedInvoice = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/deleted/View.vue');
const ViewReport = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/SalesmanReport.vue');
const ViewOpenInvoice = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/OpenInvoice');
const PendingBalanceLetter = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/PendingBalanceLetter');
const FeeChangeLetter = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/FeeChangeLetter');
const PackingSlip = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/PackingSlip');
const DeletedPackingSlip = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/deleted/PackingSlip');
const ViewPayment = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/Payment/components/View');
const viewStatement = () => import( /* webpackChunkName: "global" */ '@/modules/Invoice/components/Statement');
const ViewOrder = () => import( /* webpackChunkName: "global" */ '@/modules/Order/InHouse/components/View');


export default [{
  path: '/global',
  name: 'invoice-global',
  component: Index,
  redirect: {
    name: 'view-invoiced'
  },
  children: [{
      path: 'invoice/:id/donorInvoice',
      name: 'donor-invoice',
      component: DonorInvoice,
    },
    {
      path: 'invoice/:id/view',
      name: 'view-invoice',
      component: ViewInvoice,
    },
    {
      path: 'events/:id/view',
      name: 'view-event',
      component: ViewEvent,
    },
    {
      path: 'subscription/:id/view',
      name: 'view-subscription',
      component: ViewSubscription,
    },
    {
      path: 'invoice/deleted/:id/view',
      name: 'view-invoice-deleted',
      component: ViewDeletedInvoice,
    },
    {
      path: 'salesman/:id/view',
      name: 'view-salsman-report',
      component: ViewReport,
    },
    {
      path: 'order/:id/view',
      name: 'view-order',
      component: ViewOrder,
    },
    {
      path: 'payment/:id/view',
      name: 'view-payment',
      component: ViewPayment,
    },
    {
      path: 'statement/:id/view',
      name: 'view-statement',
      component: viewStatement,
    },
    {
      path: 'invoice/:id/packingSlip',
      name: 'view-pickingslip',
      component: PackingSlip,
    },
    {
      path: 'invoice/deleted/:id/packingSlip',
      name: 'view-pickingslip-deleted',
      component: DeletedPackingSlip,
    },
    {
      path: 'invoice/:id/openInvoice',
      name: 'view-open-invoice',
      component: ViewOpenInvoice,
    },
    {
      path: 'invoice/:id/PendingBalanceLetter',
      name: 'view-balance-letter',
      component: PendingBalanceLetter,
    },
    {
      path: 'invoice/:id/FeeChangeLetter',
      name: 'view-fee-change-letter',
      component: FeeChangeLetter,
    },
  ],
}, ]